import _ from "lodash";
import React, { useState } from "react";
import { IconLabel } from "ctia-ui";
import { Row, Table } from "react-bootstrap";
import { toggleOrder } from "helpers/SortHelper";
import NoTableData from "components/NoTableData";

const SortableTable = props => {
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const triggerSort = field => {
    const order = sortField === field ? toggleOrder(sortOrder, true) : "ASC";
    setSortField(field);
    setSortOrder(order);
  };

  const sortableColumn = (title, fieldname) => {
    return (
      <button
        className="button-no-border"
        onClick={() => triggerSort(fieldname)}
      >
        {sortField === fieldname ? (
          <IconLabel
            awesomeIcon={
              sortOrder && sortOrder.toUpperCase() === "ASC"
                ? "caret-up"
                : "caret-down"
            }
            label={title}
            iconFirst={false}
          />
        ) : (
          title
        )}
      </button>
    );
  };

  const renderList = list => {
    if (list.length === 0) {
      return <NoTableData colSpan={props.colNum} />;
    }

    const { RowRenderer } = props;

    return list.map((item, i) => {
      return <RowRenderer item={item} key={i} {...props} />;
    });
  };

  const sortedTableData = _.orderBy(
    props.list,
    item => props.handleSort(item, sortField),
    [sortOrder]
  );

  return (
    <Row>
      <Table striped condensed hover className="ctia-table">
        <thead>
          <tr>
            {props.header.map(col => {
              if (!col.title || !col.fieldname) return <th></th>;

              return <th>{sortableColumn(col.title, col.fieldname)}</th>;
            })}
          </tr>
        </thead>
        <tbody>{renderList(sortedTableData)}</tbody>
      </Table>
    </Row>
  );
};

export default SortableTable;



// WEBPACK FOOTER //
// ./src/containers/SortableTable.js